import { ICellRendererParams } from "@ag-grid-community/core";
import {
  Box,
  forwardRef,
  HStack,
  IconButton,
  IconButtonProps,
} from "@chakra-ui/react";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { MaybernTableFocusCellRendererWrapper } from "shared/components/table/maybern/MaybernTableFocusCellRendererWrapper";
import { MinusIcon } from "shared/icons/MinusIcon";
import { PlusIcon } from "shared/icons/PlusIcon";

export interface MaybernTableAddRemoveButtonsProps {
  params: ICellRendererParams;
  showAddButton: boolean;
  showRemoveButton: boolean;
  onClickAdd: () => void;
  onClickRemove: () => void;
  isDisabled?: boolean;
}

export const MaybernTableAddRemoveButtons: React.FC<
  MaybernTableAddRemoveButtonsProps
> = ({
  params,
  showAddButton,
  showRemoveButton,
  onClickAdd,
  onClickRemove,
  isDisabled,
}) => {
  const { t } = useTranslation(["common"]);
  const ref = useRef<HTMLButtonElement>(null);
  return (
    <MaybernTableFocusCellRendererWrapper params={params} inputRef={ref}>
      <HStack flex="1" spacing="8px" ml="-6px">
        {showAddButton ? (
          <AgAddRemoveButton
            ref={ref}
            aria-label={t("common:add")}
            icon={<PlusIcon />}
            onClick={onClickAdd}
            isDisabled={isDisabled}
          />
        ) : (
          <Box w="24px" h="24px" />
        )}
        <AgAddRemoveButton
          ref={showAddButton ? undefined : ref}
          aria-label={t("common:remove")}
          icon={<MinusIcon />}
          onClick={onClickRemove}
          isDisabled={!showRemoveButton || isDisabled}
        />
      </HStack>
    </MaybernTableFocusCellRendererWrapper>
  );
};

const AgAddRemoveButton = forwardRef<IconButtonProps, typeof IconButton>(
  (props, ref) => (
    <IconButton
      ref={ref}
      tabIndex={0}
      w="24px"
      h="24px"
      color="gray.500"
      padding="0 !important"
      variant="ghost"
      {...props}
    />
  ),
);
